import React from 'react';
import { siteData } from '../mock';

const About = () => {
  return (
    <section id="about" className="relative overflow-hidden bg-black py-20 lg:py-32">
      <div className="grain-overlay opacity-20"></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 lg:px-8">
        <div className="mb-14 grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:items-start">
          <div>
            <p className="mb-4 font-mono text-xs uppercase tracking-[0.28em] text-pink-accent">
              About
            </p>
            <h2 className="section-heading max-w-lg text-left">
              {siteData.about.title}
            </h2>
          </div>

          <div className="space-y-5">
            {siteData.about.paragraphs.map((paragraph) => (
              <p key={paragraph} className="body-large max-w-2xl text-white/76">
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        <div className="grid gap-5 md:grid-cols-3">
          {siteData.about.principles.map((principle) => (
            <div key={principle.title} className="rounded-[1.75rem] border border-white/10 bg-white/[0.03] p-6 backdrop-blur-sm">
              <div className="mb-4 h-1 w-14 bg-pink-accent"></div>
              <h3 className="mb-3 text-xl font-semibold text-white">{principle.title}</h3>
              <p className="text-sm leading-7 text-white/65">{principle.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
